import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import './style.css';

export default function Header() {
  return (
    <section className="header-back">
      <div className="header-overlay"></div>
      <Container className="header-hero-content" tag="main">
        <Row className="justify-content-center">
          <Col md="10">
            <h1 className="header-title text-white text-center mb-4">
              Contact Us
            </h1>
            <div className="header-subtitle text-center">
              Use this form to get in touch with us.
            </div>
            {/* Add call to action buttons here if needed */}
          </Col>
        </Row>
      </Container>
    </section>
  );
}
